/* global globalThis */
import React, { useState ,useEffect} from "react";
import { FaGoogleDrive, FaFileExcel, FaNetworkWired, FaArrowLeft } from "react-icons/fa";
import Modal from "../../../common/Modal/Modal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axiosClient from "../../../../api-client/AxiosClient";
import Spinner from "../../../common/Spinner/Spinner";
import { showError } from "../../../common/Utils";
import "./ImportData.css"; // Import your CSS file for styling

const ImportData = () => {
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedSource, setSelectedSource] = useState("");
  const [selectedCorp, setSelectedCorp] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [selectedObject, setSelectedObject] = useState("");
  const [objectDropdownData, setObjectDropdownData] = useState([]);
  const [file, setFile] = useState(null);
  const navigate = useNavigate();
  const [sourceDropdownData, setSourceDropdownData] = useState([]);
  const [templateDropdownData, setTemplateDropdownData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleExcelClick = async () => {
  setShowModal(true);
  
  // Get corporation from localStorage
  const storedCorporation = getSelectedCorporation();
  const corporationId = storedCorporation ? storedCorporation.value : null;
  
  if (corporationId) {
    // Set selectedCorp here
    setSelectedCorp(corporationId);
    
    try {
      setLoading(true);
      fetchSourcesByCorpID(corporationId);
      fetchTemplatesByCorpID(corporationId);
      fetchObjectsByCorpID(corporationId);
    } catch (error) {
      toast.error("Error fetching data");
    } finally {
      setLoading(false);
    }
  } else {
    toast.error("Please select an Organization from the header");
  }
};

const getSelectedCorporation = () => {
  const stored = localStorage.getItem("selectedCorporation");
  return stored ? JSON.parse(stored) : null;
};

  // JSON Data for sources
  const sourceData = [
    {
      id: "google_sheets",
      name: "Google Sheets",
      icon: <FaGoogleDrive size={40} color="#0F9D58" />,
      action: handleExcelClick,
    },
    {
      id: "excel_csv",
      name: "Excel/CSV",
      icon: <FaFileExcel size={40} color="#217346" />,
      action: handleExcelClick,
    },
     {
      id: "API",
      name: "API",
      icon: <FaNetworkWired size={40} color="#217346" />,
      // action: handleExcelClick,
    },
  ];

  const filteredSources = sourceData.filter((source) =>
    source.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
      const storedCorporation = getSelectedCorporation();
  const corporationId = storedCorporation ? storedCorporation.value : null;
  
  if (!corporationId) {
    toast.error("Please select an Organization from the header");
    return;
  }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file); // Append file
      formData.append("CorporationId", corporationId);
      formData.append("CorpMappingDBId", selectedSource);
      formData.append("TemplateId", selectedTemplate);
      formData.append("ObjectId", selectedObject);

      const response = await axiosClient.post("/api/Mapper/Upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("File uploaded successfully!");
      navigate("/view-data", {
        state: { fileID: response.data.userMappingFileId }, // Passing values to next page
      });
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  const handleStorageChange = (e) => {
    if (e.detail.key === "selectedCorporation") {
      // Handle corporation change if needed
    }
  };

  globalThis.addEventListener("customStorageChange", handleStorageChange);
  
  return () => {
    globalThis.removeEventListener("customStorageChange", handleStorageChange);
  };
}, []);

  const handleCancel = () => {
    setShowModal(false);
    setSelectedSource("");
    setSelectedCorp("");
    setSelectedTemplate("");
    setSelectedObject("");
    setFile(null);
    setTemplateDropdownData([]);
    setObjectDropdownData([]);
    setSourceDropdownData([]);
  };

  const fetchSourcesByCorpID = async (value) => {
    try {
      setLoading(true);
      
      const response = await axiosClient.get(
        "/api/MappingDB/CorpMappingDBByUserCorp?OrganizationConfigId=${OrganizationConfigID}",
        {
          params: { CorporationId: value },
        }
      );
      setSourceDropdownData(response.data); // Store response in state
      if (response.data.length === 1) {
        setSelectedSource(response.data[0].corpmappingdbid);
      }
    } catch (error) {
      toast.error("Error fetching Source DropDown data");
    } finally {
      setLoading(false);
    }
  };

  const fetchTemplatesByCorpID = async (value) => {
    try {
      setLoading(true);
      const response = await axiosClient.get(
        "/api/Template/GetTemplateByCorpId",
        {
          params: { CorporationId: value },
        }
      );
      setTemplateDropdownData(response.data); // Store response in state
      if (response.data.length === 1) {
        setSelectedTemplate(response.data[0].templateid);
      }
    } catch (error) {
      toast.error("Error fetching Tmplate Drop Down data");
    } finally {
      setLoading(false);
    }
  };

  const fetchObjectsByCorpID = async (value) => {
    try {
      setLoading(true);
      const response = await axiosClient.get("/api/Object/GetObjectByCorpId", {
        params: { CorporationId: value },
      });
      setObjectDropdownData(response.data); // Store response in state
    } catch (error) {
      toast.error("Error fetching Object Drop Down data");
    } finally {
      setLoading(false);
    }
  };

    const handleBack = () => navigate("/upload");



  return (
    <div className="import-container">
      {/* Show Spinner When Loading */}
      {loading && <Spinner />}
      {/* <h2>Import Data</h2> */}
       <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-bold text-gray-900">Import Mapping Docs</h2>
        <button
          onClick={handleBack}
          className="flex items-center text-blue-600 hover:text-blue-800 p-2 rounded hover:bg-blue-50 transition-colors"
          title="Go back"
        >
          <FaArrowLeft className="mr-2" />
          Back
        </button>
      </div>
      <div className="search-box">
        <input
          type="text"
          placeholder="Search for sources"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="data-sources">
        {filteredSources.map((source) => (
          <button
            key={source.id}
            className="source-card"
            onClick={source.action}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                source.action();
              }
            }}
            type="button"
          >
            {source.icon}
            <p>{source.name}</p>
          </button>
        ))}
      </div>
      {/* <div>
        <ReusableTable data={jsonData} hyperLink = {true} />
      </div> */}

      {/* Modal Popup for Excel Import */}
      {/* Reusable Modal Component */}
      <Modal
        show={showModal}
        setShowModal={setShowModal}
        title="Select Source & Upload"
      >
        {/* <div className="modal-field">
          <label>Organization</label>
          <select
            className={`static-dropdown${
              corpDropdownData?.length === 1 ? " no-arrow" : ""
            }`}
            value={selectedCorp}
            onChange={(e) => getSourceDropDownValues(e.target.value)}
            disabled={corpDropdownData?.length === 1}
          >
            {corpDropdownData?.length !== 1 && (
              <option value="">Select Organization</option>
            )}
            {corpDropdownData?.map((item) => (
              <option key={item.corporationId} value={item.corporationId}>
                {item.name}
              </option>
            ))}
          </select>
        </div> */}
        <div className="modal-field">
          <label htmlFor="source-select">Source</label>
          <select
            id="source-select"
            className={`static-dropdown${
              sourceDropdownData?.length === 1 ? " no-arrow" : ""
            }`}
            value={selectedSource}
            onChange={(e) => setSelectedSource(e.target.value)}
            disabled={sourceDropdownData?.length === 1}
          >
            {sourceDropdownData?.length !== 1 && (
              <option value="">Select Source</option>
            )}
            {sourceDropdownData?.map((item) => (
              <option key={item.corpmappingdbid} value={item.corpmappingdbid}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
        <div className="modal-field">
          <label htmlFor="template-select">Template</label>
          <select
            id="template-select"
            className={`static-dropdown${
              templateDropdownData?.length === 1 ? " no-arrow" : ""
            }`}
            value={selectedTemplate}
            onChange={(e) => setSelectedTemplate(e.target.value)}
            disabled={templateDropdownData?.length === 1}
          >
            {templateDropdownData?.length !== 1 && (
              <option value="">Select Template</option>
            )}
            {templateDropdownData?.map((item) => (
              <option key={item.templateid} value={item.templateid}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
        <div className="modal-field">
          <label htmlFor="object-select">Object Name</label>
          <select
            id="object-select"
            className="static-dropdown"
            value={selectedObject}
            onChange={(e) => setSelectedObject(e.target.value)}
          >
            <option value="">Select Object</option>
            {objectDropdownData.map((item) => (
              <option key={item.objectid} value={item.objectid}>
                {item.description}
              </option>
            ))}
          </select>
        </div>
        <div className="modal-field">
          <input type="file" accept=".xlsx, .csv" onChange={handleFileChange} />
        </div>
        <div className="modal-actions">
          <button className="cancel-btn" onClick={handleCancel}>
            Cancel
          </button>
          <button
            className={`submit-btn ${
              !selectedSource || !file || !selectedCorp || !selectedTemplate
                ? "disabled"
                : ""
            }`}
            onClick={handleSubmit}
            disabled={
              !selectedSource ||
              !file ||
              !selectedCorp ||
              !selectedTemplate ||
              !selectedObject
            }
          >
            Submit
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default ImportData;
